module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./ShoppingBagView.js"));
	}, "ShoppingBagView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=ShoppingBagView!./src/pages/PunchClock/Bean/ShoppingBag/ShoppingBagView.js
// module id = 1287
// module chunks = 431